import {useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DOMUtils from '@livongo/utils/dom';
import {PageTypes, FieldTypes} from 'utils/page';
import Image from 'ui/Image';
import WithPage from '../WithPage';

const {TITLE, BODY} = FieldTypes;

const ImageAndText = ({data, uuid, onShowDefinitions}) => {
    const textFields = data.getTextFieldsMap();
    const imageType =
        data.getPageType() === PageTypes.ICON_PAGE
            ? 'ICON_IMAGE'
            : 'HERO_IMAGE';
    const title = textFields.get(TITLE).getTextValue();
    const contentClass = `ImageAndText-content-${uuid}`;
    const termTarget = `.${contentClass} .term`;
    const contentClasses = classNames('ImageAndText-content', contentClass);

    useEffect(() => {
        DOMUtils.addEventListener({
            event: 'click',
            target: termTarget,
            handler: onShowDefinitions,
        });

        return () => {
            DOMUtils.removeEventListener({
                event: 'click',
                target: termTarget,
                handler: onShowDefinitions,
            });
        };
    }, [termTarget, onShowDefinitions]);

    return (
        <div className="ImageAndText">
            <div className="Image-aspect-container">
                <Image
                    src={data.getImageFieldsMap().get(imageType).getImageSrc()}
                    alt={title}
                />
            </div>
            <div className={contentClasses}>
                <h1>{title}</h1>
                <div
                    dangerouslySetInnerHTML={{
                        __html: textFields.get(BODY).getTextValue(),
                    }}
                />
            </div>
        </div>
    );
};

ImageAndText.propTypes = {
    data: PropTypes.object.isRequired,
    uuid: PropTypes.string.isRequired,
    onShowDefinitions: PropTypes.func,
};

export default WithPage(ImageAndText);
